import { ls } from "@/utils/cache";
import { ROOMINFO } from "@/store/mutation-types";
const room = {
  state: {
    info: {},
    roomStatusShowType: "1",
  },

  mutations: {
    SET_ROOM_INFO: (state, info) => {
      state.info = info;
    },
    SET_ROOM_STATUS_SHOWTYPE: (state, info) => {
      state.roomStatusShowType = info;
    },
  },

  actions: {
    setRoomInfo({ commit }, info) {
      ls.set(ROOMINFO, info);
      commit("SET_ROOM_INFO", info);
    },
    setRoomStatusShowType({ commit }, info) {
      commit("SET_ROOM_STATUS_SHOWTYPE", info);
    },
  },
};

export default room;
